<template>
  <div class="form-entity">
    <slot />
  </div>
</template>

<script>
const componentName = 'FormEntity'
export default {
  name: componentName,

  componentName,

  props: {
    // form-field 的数据源
    model: {
      type: Object,
      default: () => {}
    },
    rules: {
      type: Object,
      default: () => {}
    },
    size: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.form-entity {
  border-radius: 2px;
  margin-bottom: 10px;
}
</style>
